var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{attrs:{"rounded":"","outlined":"","color":"primary"},on:{"click":_vm.action}},[_vm._v(" "+_vm._s(_vm.$t("action.back"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }